import Headers from './components/Header';
import Footer from './components/footer';
import MarqueeBanner from './components/MarqueeBanner';
import ScrollToTop from './components/ScrollToTop';
import Chatbot from './components/Chatbot';
import './App.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ProductDetail from './pages/productDetail';
import { useState, useEffect } from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cart from './pages/Cart';
import Login from "./pages/Login";
import Register from "./pages/Register";
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import NewArrivals from './pages/NewArrivals';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import AdminRoute from './components/AdminRoute';
import AdminUsers from './pages/AdminUsers';
import AdminProducts from './pages/AdminProducts';
import ProtectedRoute from './components/ProtectedRoute';

import AnimatedPage from './components/AnimatedPage';
import { AnimatePresence } from 'framer-motion';

import AOS from 'aos';
import 'aos/dist/aos.css';

function AppContent() {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const item = window.localStorage.getItem('cartItems');
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.warn("Error reading localStorage", error);
      return [];
    }
  });

  const updateCartItems = (newItems) => {
    setCartItems(newItems);
    window.localStorage.setItem('cartItems', JSON.stringify(newItems));
  };

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 60,
      delay: 0,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [location.pathname]);

  return (
    <div className="main-app">
      <ToastContainer theme='dark' position='top-center' />
      
      {!isAdminRoute && <Headers cartItems={cartItems} />}
      {!isAdminRoute && location.pathname === '/' && <MarqueeBanner />}
      
      <main className={!isAdminRoute && location.pathname === '/' ? 'home-main-container' : `main-container ${!isAdminRoute ? 'page-offset' : ''}`}>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<AnimatedPage><Home /></AnimatedPage>} />
            <Route path="/search" element={<AnimatedPage><Home /></AnimatedPage>} />
            <Route path="/new" element={<AnimatedPage><NewArrivals /></AnimatedPage>} />
            <Route path="/about" element={<AnimatedPage><AboutUs /></AnimatedPage>} />
            <Route path="/contact" element={<AnimatedPage><Contact /></AnimatedPage>} />
            <Route path="/product/:id" element={<AnimatedPage><ProductDetail cartItems={cartItems} setCartItems={updateCartItems} /></AnimatedPage>} />
            <Route path="/cart" element={<AnimatedPage><Cart cartItems={cartItems} setCartItems={updateCartItems} /></AnimatedPage>} />
            <Route path="/login" element={<AnimatedPage><Login /></AnimatedPage>} />
            <Route path="/register" element={<AnimatedPage><Register /></AnimatedPage>} />

            <Route path="/user/dashboard" element={
              <ProtectedRoute><AnimatedPage><UserDashboard /></AnimatedPage></ProtectedRoute>
            } />

            <Route path="/admin/products" element={
              <ProtectedRoute><AdminRoute><AnimatedPage><AdminProducts /></AnimatedPage></AdminRoute></ProtectedRoute>
            } />

            <Route path="/admin/dashboard" element={
              <ProtectedRoute><AdminRoute><AnimatedPage><AdminDashboard /></AnimatedPage></AdminRoute></ProtectedRoute>
            } />
            
            <Route path="/admin/users" element={
              <ProtectedRoute><AdminRoute><AnimatedPage><AdminUsers /></AnimatedPage></AdminRoute></ProtectedRoute>
            } />
          </Routes>
        </AnimatePresence>
      </main>
      
      {!isAdminRoute && <Footer />}
      <ScrollToTop />
      
      {/* Chatbot — bottom right */}
      {!isAdminRoute && <Chatbot isAdminRoute={isAdminRoute} />}

      {/* WhatsApp Floating Button — bottom left */}
      {!isAdminRoute && (
        <a 
          href="https://wa.me/0773155125" 
          className="whatsapp-float" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <svg viewBox="0 0 24 24" width="30" height="30" fill="white">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </a>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
